const Loader = () => (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(255, 255, 255, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10,
      }}
    >
      <div>
        <img src={"media/logos/loader.gif"} alt="Loading animation" width="50" />
      </div>
    </div>
  );
  
  export default Loader;
  